module.exports = __webpack_public_path__ + "static/media/dashboard.cad29968.png";